"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Tile = require("./Tile");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Tiles = ({
  features,
  onSelectFeature,
  onRemoveFeature,
  showCustomization,
  onDragEnd
}) => {
  const [tiles, setTiles] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setTiles(features);
  }, [features]);
  const _tempTiles = tiles;
  return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: param => {
      var _param$destination;

      const srcI = param.source.index;
      const desI = (_param$destination = param.destination) === null || _param$destination === void 0 ? void 0 : _param$destination.index;

      if (desI) {
        _tempTiles.splice(desI, 0, _tempTiles.splice(srcI, 1)[0]);

        setTiles(_tempTiles);

        if ('function' == typeof onDragEnd) {
          onDragEnd(_tempTiles);
        }
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable-1",
    type: "items"
  }, provided => /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: provided.innerRef
  }, provided.droppableProps), tiles.map(({
    iconName,
    label,
    id,
    ...rest
  }, i) => /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
    key: label,
    index: i,
    draggableId: `draggable-${id}`,
    isDragDisabled: !showCustomization
  }, (provided, snapshot) => {
    return /*#__PURE__*/_react.default.createElement(_Tile.IconTile, _extends({
      iconName: iconName,
      key: label,
      label: label,
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps, {
      style: { ...provided.draggableProps.style
      },
      isDragging: snapshot.isDragging,
      onClick: () => onSelectFeature({
        iconName,
        label,
        id,
        ...rest
      }),
      onRemove: () => onRemoveFeature({
        iconName,
        label,
        id,
        ...rest
      }),
      showCustomization: showCustomization
    }));
  })))));
};

Tiles.defaultProps = {
  features: [],
  onSelectFeature: () => null,
  onRemoveFeature: () => null,
  onDragEnd: () => null,
  showCustomization: false
};
Tiles.propTypes = {
  features: _propTypes.default.array,
  onSelectFeature: _propTypes.default.func,
  onRemoveFeature: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  showCustomization: _propTypes.default.bool
};
var _default = Tiles;
exports.default = _default;